import { Button } from '@mui/material';
import { useMemo } from 'react';

interface IProps {
  label: string;
  value: boolean;
  setSelected: React.Dispatch<React.SetStateAction<boolean>>;
  classname?: string;
  disabled?: boolean;
}

import './styles.scss';

const DEFAULT_CLASS_NAME = `radio-button`;

const RadioButton = (props: IProps) => {
  const { classname, value, disabled, setSelected, label } = props;

  const buttonClassName = useMemo(() => {
    let name = DEFAULT_CLASS_NAME;

    if (classname) {
      name += ' ' + classname;
    }

    if (value) {
      name += ' selected';
    }

    return name;
  }, [classname, value]);

  return (
    <Button className={buttonClassName} onClick={() => !disabled && setSelected(value)}>
      {label}
    </Button>
  );
};

export default RadioButton;
